<template>
  <div class="picker-main">
    <div v-if="isDisabled" class="disable-block"></div>
    <div
      class="picker-label"
      ><span v-if="isRequired" style="color: red; margin-right: 3px; font-size: 10px">**</span>{{ placeholder }}:
    </div>
    <div
      class="date-time-box"
      :style="{
        borderColor:
          isDisabled ? 'rgb(200,200,200)'
          : dateIsValid ? 'black'
          : 'red',
        backgroundColor: dateIsValid ? 'transparent' : 'rgba(255,0,0,0.2)',
      }"
    >
      <div class="date-time">
        <input
          style="width: 2.5em"
          placeholder="yyyy"
          v-model="yearInput"
          ref="yearIn"
          :disabled="isDisabled"
          @keydown="dateInputKeydown('year', $event)"
          @input="checkFullDate"
          @blur="yearInputBlurred"
        />
        <div>-</div>
        <input
          placeholder="MM"
          v-model="monthInput"
          ref="monthIn"
          :disabled="isDisabled"
          @keydown="dateInputKeydown('month', $event)"
          @input="checkFullDate"
          @blur="monthInputBlurred"
        />
        <div v-if="!showMonthOnly">-</div>
        <input
          v-if="!showMonthOnly"
          placeholder="dd"
          v-model="dayInput"
          ref="dayIn"
          :disabled="isDisabled"
          @keydown="dateInputKeydown('day', $event)"
          @input="checkFullDate"
          @blur="dayInputBlurred"
        />

        <input
          v-if="showTime"
          style="margin-left: 5px"
          placeholder="00"
          v-model="hourInput"
          ref="hourIn"
          :disabled="isDisabled"
          @keydown="dateInputKeydown('hour', $event)"
          @input="checkFullDate"
          @blur="hourInputBlurred"
        />
        <div v-if="showTime">:</div>
        <input
          v-if="showTime"
          placeholder="00"
          v-model="minuteInput"
          ref="minuteIn"
          :disabled="isDisabled"
          @keydown="dateInputKeydown('minute', $event)"
          @input="checkFullDate"
          @blur="minuteInputBlurred"
        />
      </div>
      <div class="calendar-icon-container" @click="calendarClicked">
        <img src="https://dsmlib.logistics.systems/Icons/Calendar.png" alt="calendar" />
      </div>
      <div
        v-if="showCalendar"
        class="calendar"
        :class="{ upwards: popupUpwards }"
        ref="calendarElement"
        :style="{ top: calendarTop }"
      >
        <div class="calendar-button">
          <button @click="todayClicked">Today</button>
          <button @click="clearDateClicked">Clear</button>
        </div>
        <div class="year-month">
          <div class="previous" @click="previousNextClick('year', false)">&lt;</div>
          <div class="content">{{ calendarDate.getFullYear() }}</div>
          <div class="next" @click="previousNextClick('year', true)">&gt;</div>
        </div>
        <div v-if="!showMonthOnly" class="year-month">
          <div class="previous" @click="previousNextClick('month', false)">&lt;</div>
          <div class="content">{{ fullMonth[calendarDate.getMonth()] }}</div>
          <div class="next" @click="previousNextClick('month', true)">&gt;</div>
        </div>

        <div v-show="!showMonthOnly" class="days-date-section">
          <div v-for="(sd, sdi) in shortDays" :key="sdi" class="content-no-hover">{{ sd }}</div>
          <div
            v-for="(d, di) in allDates"
            :key="`d${d}i${di}aDates`"
            :class="[
              {
                today:
                  Date.parse(`${calendarDate.getFullYear()}-${calendarDate.getMonth()}-${d}`) ==
                  Date.parse(`${new Date().getFullYear()}-${new Date().getMonth()}-${new Date().getDate()}`),
                disabled: isDisabledDate(d),
                dates: d,
                selected: selectedDate(d),
              },
              d ? 'content' : 'content-no-hover',
            ]"
            @click="dateClicked(d)"
          >
            {{ d }}
          </div>
        </div>

        <div v-if="showMonthOnly" class="month-date-section">
          <div
            v-for="(m, mi) in fullMonth"
            :key="`m${m}i${mi}aDates`"
            :class="[
              {
                today:
                  Date.parse(`${calendarDate.getFullYear()}-${fullMonth.indexOf(m)}-1`) ==
                  Date.parse(`${new Date().getFullYear()}-${new Date().getMonth()}-1`),
                disabled: isDisabledMonth(fullMonth.indexOf(m)),
                selected: selectedMonth(fullMonth.indexOf(m)),
              },
              m ? 'content' : 'content-no-hover',
            ]"
            @click="monthClicked(fullMonth.indexOf(m))"
          >
            {{ m }}
          </div>
        </div>

        <div v-if="showTime" class="time-section">
          <input
            style="margin-left: 5px"
            placeholder="00"
            v-model="hourInput"
            ref="calendarHourIn"
            :disabled="isDisabled"
            @keydown="dateInputKeydown('calendarHour', $event)"
            @input="checkFullDate"
            @blur="hourInputBlurred"
          />
          <div>:</div>
          <input
            placeholder="00"
            v-model="minuteInput"
            ref="calendarMinuteIn"
            :disabled="isDisabled"
            @keydown="dateInputKeydown('calendarMinute', $event)"
            @input="checkFullDate"
            @blur="minuteInputBlurred"
          />
        </div>
      </div>
      <div v-if="errorMessage" class="error-message" @click="errorClicked">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      dayInput: '',
      monthInput: '',
      yearInput: '',
      hourInput: '',
      minuteInput: '',

      privateValue: null,

      dateIsValid: true,

      showCalendar: false,
      calendarDate: new Date(),
      fullMonth: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      allDates: [],

      calendarTop: '',

      teleportedCalendar: null,
    };
  },
  props: {
    value: {
      type: Date,
      default: function () {
        return null;
      },
    },
    showTime: { type: Boolean, default: true },
    showMonthOnly: { type: Boolean, default: false },
    maxDate: {
      type: Date,
      default: function () {
        return null;
      },
    },
    minDate: {
      type: Date,
      default: function () {
        return new Date(1900, 0, 1);
      },
    }, // default min date is 1st Jan 1900
    isDisabled: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Date' },
    errorMessage: { type: String, default: '' },
    isRequired: { type: Boolean, default: false },

    popupUpwards: { type: Boolean, default: false },

    // public events
    // @dateChanged(newValue, oldValue) - fired when the value of the date time picker changes, will not fire if value is changed programatically
  },
  computed: {
    parsedYearInput: function () {
      return parseInt(this.yearInput);
    },
    parsedMonthInput: function () {
      if (this.showMonthOnly) {
        this.dayInput = '01';
      }
      return parseInt(this.monthInput);
    },
    parsedDayInput: function () {
      return parseInt(this.dayInput);
    },
    parsedHourInput: function () {
      return parseInt(this.hourInput);
    },
    parsedMinuteInput: function () {
      return parseInt(this.minuteInput);
    },
    calendarStyle() {
      return {
        position: 'fixed',
        zIndex: '2147483647',
        width: '100%',
        minWidth: '176px',
        padding: '5px',
        backgroundColor: 'white',
        border: '1px solid black',
        borderRadius: '5px',
        userSelect: 'none',
      };
    },
  },
  methods: {
    calendarClicked: function () {
      if (!this.isDisabled) {
        this.showCalendar = !this.showCalendar;
      }
    },
    isDisabledDate: function (date) {
      if (!date) {
        return false;
      }

      let currentDate = new Date().setHours(0, 0, 0, 0);
      if (typeof date == 'number') {
        let year = this.calendarDate.getFullYear();
        let month = this.calendarDate.getMonth();

        currentDate = new Date(year, month, date).setHours(0, 0, 0, 0);
      }

      let min = this.minDate ? this.minDate.setHours(0, 0, 0, 0) : null;
      let max = this.maxDate ? this.maxDate.setHours(0, 0, 0, 0) : null;

      if (!min && !max) {
        return false;
      } else if (min && !max) {
        // Only min date is set
        return currentDate < min;
      } else if (!min && max) {
        // Only max date is set
        return currentDate > max;
      } else {
        // Max and min date is set
        return currentDate < min || currentDate > max;
      }
    },
    isDisabledMonth: function (month) {
      if (month != 0 && !month) { //0 is falsy value
        return false;
      }

      let currentDate = new Date().setHours(0, 0, 0, 0);
      if (typeof month == 'number') {
        let year = this.calendarDate.getFullYear();
        
        currentDate = new Date(year, month, 1).setHours(0, 0, 0, 0);
      }

      let min = this.minDate ? this.minDate.setHours(0, 0, 0, 0) : null;
      let max = this.maxDate ? this.maxDate.setHours(0, 0, 0, 0) : null;
      if (!min && !max) {
        return false;
      } else if (min && !max) {
        // Only min date is set
        return currentDate < min;
      } else if (!min && max) {
        // Only max date is set
        return currentDate > max;
      } else {
        // Max and min date is set
        return currentDate < min || currentDate > max;
      }
    },
    selectedDate: function (date) {
      if (this.privateValue) {
        let valueYear = this.privateValue.getFullYear();
        let valueMonth = this.privateValue.getMonth();
        let valueDate = this.privateValue.getDate();

        let calYear = this.calendarDate.getFullYear();
        let calMonth = this.calendarDate.getMonth();

        return new Date(valueYear, valueMonth, valueDate).getTime() == new Date(calYear, calMonth, date).getTime();
      } else {
        return false;
      }
    },
    selectedMonth: function (month) {
      if (this.privateValue) {
        let valueYear = this.privateValue.getFullYear();
        let valueMonth = this.privateValue.getMonth();
        let valueDate = '1';

        let calYear = this.calendarDate.getFullYear();
        let calDate = '1';

        return new Date(valueYear, valueMonth, valueDate).getTime() == new Date(calYear, month, calDate).getTime();
      } else {
        return false;
      }
    },
    dateInputKeydown: function (dateSegment, keyboardEvent) {
      // the <input />s need to be of type="text", instead of type="number", because selectionStart and selectionEnd don't work for type="number"
      // https://stackoverflow.com/questions/21177489/selectionstart-selectionend-on-input-type-number-no-longer-allowed-in-chrome
      // and because it's of type="text", will need to manually validate input to ensure only numbers are entered

      switch (keyboardEvent.key) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6': // if a number was inputted
        case '7': // first check if the length limit has been reached, it it hasn't then allow the input
        case '8': // if the length limt has been reached, check if any of the text is selected
        case '9': // if it is, then allow the input
          switch (dateSegment) {
            case 'year':
              if (this.yearInput.length < 4) {
                // if less than 4 digits are inputted
                return; // allow the input
              }
              if (this.$refs.yearIn.selectionStart !== this.$refs.yearIn.selectionEnd) {
                // if some of the text is selected
                return; // allow the input
              }
              break; // else, disallow the input

            case 'month':
              if (this.monthInput.length < 2) {
                // if less than 2 digits are inputted
                return; // allow the input
              }
              if (this.$refs.monthIn.selectionStart !== this.$refs.monthIn.selectionEnd) {
                // if some of the text is selected
                return; // allow the input
              }
              break; // else, disallow the input

            case 'day':
              if (this.dayInput.length < 2) {
                // if less than 2 digits are inputted
                return; // allow the input
              }
              if (this.$refs.dayIn.selectionStart !== this.$refs.dayIn.selectionEnd) {
                // if some of the text is selected
                return; // allow the input
              }
              break; // else, disallow the input

            case 'hour':
              if (this.hourInput.length < 2) {
                // if less than 2 digits are inputted
                return; // allow the input
              }
              if (this.$refs.hourIn.selectionStart !== this.$refs.hourIn.selectionEnd) {
                // if some of the text is selected
                return; // allow the input
              }
              break; // else, disallow the input

            case 'minute':
              if (this.minuteInput.length < 2) {
                // if less than 2 digits are inputted
                return; // allow the input
              }
              if (this.$refs.minuteIn.selectionStart !== this.$refs.minuteIn.selectionEnd) {
                // if some of the text is selected
                return; // allow the input
              }
              break; // else, disallow the input

            case 'calendarHour':
              if (this.hourInput.length < 2) {
                // if less than 2 digits are inputted
                return; // allow the input
              }
              if (this.$refs.calendarHourIn.selectionStart !== this.$refs.calendarHourIn.selectionEnd) {
                // if some of the text is selected
                return; // allow the input
              }
              break; // else, disallow the input

            case 'calendarMinute':
              if (this.minuteInput.length < 2) {
                // if less than 2 digits are inputted
                return; // allow the input
              }
              if (this.$refs.calendarMinuteIn.selectionStart !== this.$refs.calendarMinuteIn.selectionEnd) {
                // if some of the text is selected
                return; // allow the input
              }
              break; // else, disallow the input
          }
          break;

        case 'Backspace':
        case 'Delete':
        case 'ArrowLeft':
        case 'ArrowRight':
        case 'Tab':
        case 'Home':
        case 'End':
          return; // always allow these inputs regardless
          break;
      }

      keyboardEvent.preventDefault(); // prevent all other inputs
    },
    convertShortYearToFullYear: function (year) {
      // convert 1, 2, 3 digit years to a full 4 digit year
      // e.g. convert 14 to 2014, 23 to 2023, etc.
      // year parameter should be a Number

      const currentYear = new Date().getFullYear();
      const currentCentury = currentYear - (currentYear % 100);
      return year < 1000 ? year + currentCentury : year;
    },
    checkFullDate: function () {
      // sets the dateIsValid data member, and returns a string indicating date validation result (because JS doesn't support enums)

      if (
        this.showTime &&
        (isNaN(this.parsedYearInput) ||
          this.parsedYearInput < 0 ||
          this.parsedYearInput > 9999 || // all fields must be filled for the date to be considered valid
          isNaN(this.parsedMonthInput) ||
          this.parsedMonthInput < 1 ||
          this.parsedMonthInput > 12 || // if any of the fields are not filled
          isNaN(this.parsedDayInput) ||
          this.parsedDayInput < 1 ||
          this.parsedDayInput > 31 || // consider the input invalid
          isNaN(this.parsedHourInput) ||
          this.parsedHourInput < 0 ||
          this.parsedHourInput > 23 ||
          isNaN(this.parsedMinuteInput) ||
          this.parsedMinuteInput < 0 ||
          this.parsedMinuteInput > 59)
      ) {
        this.dateIsValid = false;
        return 'invalid';
      }

      if (
        !this.showTime &&
        (isNaN(this.parsedYearInput) ||
          this.parsedYearInput < 0 ||
          this.parsedYearInput > 9999 || // all fields must be filled for the date to be considered valid
          isNaN(this.parsedMonthInput) ||
          this.parsedMonthInput < 1 ||
          this.parsedMonthInput > 12 || // if any of the fields are not filled
          isNaN(this.parsedDayInput) ||
          this.parsedDayInput < 1 ||
          this.parsedDayInput > 31) // consider the input invalid
      ) {
        this.dateIsValid = false;
        return 'invalid';
      }

      const fullYear = this.convertShortYearToFullYear(this.parsedYearInput);
      const monthIndex = this.parsedMonthInput - 1;
      let dateInputted;
      if (this.showTime) {
        // check for overflows
        dateInputted = new Date(fullYear, monthIndex, this.dayInput, this.hourInput, this.minuteInput);
        if (
          dateInputted.getFullYear() !== fullYear || // if any of these mismatch, an overflow occurred
          dateInputted.getMonth() !== monthIndex ||
          dateInputted.getDate() !== this.parsedDayInput ||
          dateInputted.getHours() !== this.parsedHourInput ||
          dateInputted.getMinutes() !== this.parsedMinuteInput
        ) {
          this.dateIsValid = false;
          return 'invalid';
        }
      } else {
        // check for overflows
        dateInputted = new Date(fullYear, monthIndex, this.dayInput);
        if (
          dateInputted.getFullYear() !== fullYear || // if any of these mismatch, an overflow occurred
          dateInputted.getMonth() !== monthIndex ||
          dateInputted.getDate() !== this.parsedDayInput
        ) {
          this.dateIsValid = false;
          return 'invalid';
        }
      }

      if (this.minDate && dateInputted < this.minDate) {
        this.dateIsValid = false;
        return 'outofrange';
      }

      if (this.maxDate && dateInputted > this.maxDate) {
        this.dateIsValid = false;
        return 'outofrange';
      }

      this.dateIsValid = true;
      return 'valid';
    },
    yearInputBlurred: function (focusEvent) {
      if (isNaN(this.parsedYearInput)) {
        this.yearInput = '';
      } else if (this.parsedYearInput < 0 || this.parsedYearInput > 9999) {
        this.yearInput = new Date().getFullYear().toString(); // change to current year
      } else {
        this.yearInput = this.convertShortYearToFullYear(this.parsedYearInput).toString();
      }

      this.tryPropagateDateChanges(focusEvent);
    },
    monthInputBlurred: function (focusEvent) {
      if (isNaN(this.parsedMonthInput)) {
        this.monthInput = '';
      } else if (this.parsedMonthInput < 1) {
        this.monthInput = '01';
      } else if (this.parsedMonthInput > 12) {
        this.monthInput = '12';
      } else {
        this.monthInput = this.monthInput.padStart(2, '0');
      }

      this.tryPropagateDateChanges(focusEvent);
    },
    dayInputBlurred: function (focusEvent) {
      if (isNaN(this.parsedDayInput)) {
        this.dayInput = '';
      } else {
        const lastDay =
          (
            !isNaN(this.parsedYearInput) && isNaN(this.parsedMonthInput) // if year and month are already entered
          ) ?
            new Date(this.parsedYearInput, this.parsedMonthInput - 1, 0).getDate() // get the last day of that month
          : 31; // else, default to 31

        if (this.parsedDayInput < 1) {
          this.dayInput = '01';
        } else if (this.parsedDayInput > lastDay) {
          this.dayInput = lastDay.toString();
        } else {
          this.dayInput = this.dayInput.padStart(2, '0');
        }
      }

      this.tryPropagateDateChanges(focusEvent);
    },
    hourInputBlurred: function (focusEvent) {
      if (isNaN(this.parsedHourInput)) {
        this.hourInput = '';
      } else if (this.parsedHourInput < 0) {
        this.hourInput = '00';
      } else if (this.parsedHourInput > 23) {
        this.hourInput = '23';
      } else {
        this.hourInput = this.hourInput.padStart(2, '0');
      }

      this.tryPropagateDateChanges(focusEvent);
    },
    minuteInputBlurred: function (focusEvent) {
      if (isNaN(this.parsedMinuteInput)) {
        this.minuteInput = '';
      } else if (this.parsedMinuteInput < 0) {
        this.minuteInput = '00';
      } else if (this.parsedMinuteInput > 59) {
        this.minuteInput = '59';
      } else {
        this.minuteInput = this.minuteInput.padStart(2, '0');
      }

      this.tryPropagateDateChanges(focusEvent);
    },
    tryPropagateDateChanges: function (focusEvent) {
      // updates date prop and data when certain conditions are met
      // only used when typing a date either into the inline inputs or into the hour and minute inputs within the calendar popup
      // does not run when the user selects a day from the calendar popup

      const dateSegmentInputs = [
        this.$refs['yearIn'],
        this.$refs['monthIn'],
        this.$refs['dayIn'],
        this.$refs['hourIn'],
        this.$refs['minuteIn'],
        this.$refs['calendarHourIn'],
        this.$refs['calendarMinuteIn'],
      ];

      if (
        dateSegmentInputs.some((input) => {
          return input === focusEvent.relatedTarget;
        })
      ) {
        return; // focus was changed to another date segment input, don't update data and prop yet
      }

      // focus was taken out of the whole datetimepicker
      // hide the calendar, because pressing tab in the minute input within the calendar popup will take the focus out of the whole datetimepicker as well
      this.showCalendar = false;

      if (this.checkFullDate() === 'invalid') {
        // if focus was taken out of the whole datetimepicker and the date is still invalid
        this.dateIsValid = true; // remove red background and underline
        this.clearInput();
        this.privateValue = null;
        this.$emit('dateChanged', this.privateValue, this.value);
        this.$emit('update:value', this.privateValue);
        return;
      }

      // else if out of range or date is valid, proceed to update data and prop
      // if it's out of range, leave the background as red

      this.privateValue =
        this.showTime ?
          new Date(
            this.parsedYearInput,
            this.parsedMonthInput - 1,
            this.parsedDayInput,
            this.parsedHourInput,
            this.parsedMinuteInput,
          )
        : new Date(this.parsedYearInput, this.parsedMonthInput - 1, this.parsedDayInput);
      this.$emit('dateChanged', this.privateValue, this.value);
      this.$emit('update:value', this.privateValue);
    },
    populateCalendar: function (bypass) {
      if (!bypass) {
        if (Date.parse(this.privateValue)) {
          this.calendarDate = new Date(
            this.privateValue.getFullYear(),
            this.privateValue.getMonth(),
            this.privateValue.getDate(),
          );
        } else {
          this.calendarDate = new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
        }
      }
      let tempDates = [];

      let maxDate = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth() + 1, 0).getDate();
      let dates = [...Array(maxDate)].map((_, index) => index + 1);

      let startDay = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), 1).getDay();
      let emptyStart = new Array(startDay);

      let endDay = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), maxDate).getDay();
      let emptyEnd = new Array(6 - endDay);

      tempDates = tempDates.concat(emptyStart);
      tempDates = tempDates.concat(dates);
      tempDates = tempDates.concat(emptyEnd);

      this.allDates = tempDates;
    },
    populateInput: function () {
      if (!this.privateValue || this.privateValue.toString() === 'Invalid Date') {
        return;
      }

      this.yearInput = this.privateValue.getFullYear().toString();
      this.monthInput = (this.privateValue.getMonth() + 1).toString().padStart(2, '0');
      this.dayInput = this.privateValue.getDate().toString().padStart(2, '0');

      if (this.showTime) {
        this.hourInput = this.privateValue.getHours().toString().padStart(2, '0');
        this.minuteInput = this.privateValue.getMinutes().toString().padStart(2, '0');
      } else {
        this.hourInput = '';
        this.minuteInput = '';
      }
    },
    clearInput: function () {
      this.dayInput = '';
      this.monthInput = '';
      this.yearInput = '';
      this.hourInput = '';
      this.minuteInput = '';
    },
    previousNextClick: function (type, next) {
      let year = this.calendarDate.getFullYear();
      let month = this.calendarDate.getMonth();

      this.calendarDate.setDate(1);

      if (next) {
        switch (type) {
          case 'year':
            // this.calendarDate = new Date(this.calendarDate.setFullYear(year + 1));
            this.calendarDate.setFullYear(year + 1);
            break;
          case 'month':
            // this.calendarDate = new Date(this.calendarDate.setMonth(month + 1));
            this.calendarDate.setMonth(month + 1);
            break;
        }
      } else {
        switch (type) {
          case 'year':
            this.calendarDate.setFullYear(year - 1);
            // this.calendarDate = new Date(this.calendarDate.setFullYear(year - 1));
            break;
          case 'month':
            this.calendarDate.setMonth(month - 1);
            // this.calendarDate = new Date(this.calendarDate.setMonth(month - 1));
            break;
        }
      }

      this.populateCalendar(true);
    },
    dateClicked: function (date) {
      if (date) {
        if (this.isDisabledDate(date)) return;

        let year = this.calendarDate.getFullYear();
        let month = this.calendarDate.getMonth();

        this.calendarDate = new Date(year, month, date);
        this.privateValue = new Date(year, month, date);

        this.$emit('dateChanged', this.privateValue, this.value);
        this.$emit('update:value', this.privateValue);
        this.$emit('update:errorMessage', '');
        this.$nextTick(() => {
          this.populateInput();
          this.showCalendar = false;
        });
      }
    },
    monthClicked: function (month) {
      if (this.isDisabledMonth(month)) return;
      if (month || month == 0) {
        let year = this.calendarDate.getFullYear();
        let date = '1';

        this.calendarDate = new Date(year, month, date);
        this.privateValue = new Date(year, month, date);

        this.$emit('dateChanged', this.privateValue, this.value);
        this.$emit('update:value', this.privateValue);
        this.$emit('update:errorMessage', '');
        this.$nextTick(() => {
          this.populateInput();
          this.showCalendar = false;
        });
      }
    },
    errorClicked: function () {
      this.$emit('update:errorMessage', '');
      this.$refs.yearIn.focus();
    },
    setFocus: function () {
      this.$emit('update:errorMessage', '');
      this.$refs.yearIn.focus();
    },

    clearDateClicked: function () {
      this.privateValue = null;
      this.$emit('dateChanged', this.privateValue, this.value);
      this.$emit('update:value', this.privateValue);
      this.$nextTick(() => {
        this.clearInput();
        this.populateCalendar();
      });
    },
    todayClicked: function () {
      if (!this.isDisabledDate(new Date())) {
        this.privateValue = new Date();
        this.$emit('dateChanged', this.privateValue, this.value);
        this.$emit('update:value', this.privateValue);
        this.$emit('update:errorMessage', '');
        this.$nextTick(() => {
          this.populateInput();
          this.populateCalendar();
          this.showCalendar = false;
        });
      }
    },
    positionCalendar() {
      if (!this.teleportedCalendar) return;
      const rect = this.$el.getBoundingClientRect();
      const calHeight = this.teleportedCalendar.offsetHeight;
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      const goUpwards = spaceBelow < calHeight && spaceAbove > spaceBelow;

      if (goUpwards) {
        this.teleportedCalendar.style.top = (rect.top - calHeight) + 'px';
      } else {
        this.teleportedCalendar.style.top = rect.bottom + 'px';
      }
      this.teleportedCalendar.style.left = rect.left + 'px';
    },

    onDocumentMouseDown: function (event) {
      if (
        !this.showCalendar ||
        this.$el.contains(event.target) ||
        (this.teleportedCalendar && this.teleportedCalendar.contains(event.target))
      ) {
        return;
      }
      this.showCalendar = false;
    },

    onCalendarScroll() {
      if (this.showCalendar) {
        requestAnimationFrame(() => this.positionCalendar());
      }
    },

    attachCalendarTeleport() {
      const cal = this.$refs.calendarElement;
      if (!cal || this.teleportedCalendar) return;
      cal.addEventListener('mousedown', (e) => e.preventDefault());
      cal.style.position = 'fixed';
      cal.style.zIndex = '99998';
      cal.style.top = 'auto';
      cal.style.left = 'auto';
      this.$getOverlayRoot().appendChild(cal);
      this.teleportedCalendar = cal;
      this.positionCalendar();
      document.addEventListener('mousedown', this.onDocumentMouseDown, true);
      window.addEventListener('scroll', this.onCalendarScroll, true);
      window.addEventListener('resize', this.onCalendarScroll);
    },

    detachCalendarTeleport() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown, true);
      window.removeEventListener('scroll', this.onCalendarScroll, true);
      window.removeEventListener('resize', this.onCalendarScroll);
      if (this.teleportedCalendar && this.teleportedCalendar.parentNode) {
        this.teleportedCalendar.parentNode.removeChild(this.teleportedCalendar);
      }
      this.teleportedCalendar = null;
    },
  },
  mounted() {
    if (this.value) {
      this.privateValue = this.value;
      this.populateInput();

      this.$nextTick(() => this.checkFullDate());
    }
  },
  watch: {
    showCalendar: function (val) {
      if (val) {
        this.populateCalendar();
        this.$nextTick(() => {
          this.attachCalendarTeleport();
        });
      } else {
        this.detachCalendarTeleport();
        this.calendarTop = '';
      }
    },
    value: function (val) {
      this.privateValue = val;
      if (val) {
        this.populateInput();
      } else {
        this.clearInput();
      }
    },
  },
  beforeDestroy() {
    this.detachCalendarTeleport();
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.picker-main {
  display: flex;
  // justify-content: center;
  height: 25px;
  font-size: 12px;
  position: relative;
  margin: 2px 0;
  align-items: center;
  top: -3px;
  // width: 100%;
  // background-color: yellow;

  > .picker-label {
    line-height: 1;
  }

  > .date-time-box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    // border: 1px solid black;
    // border-radius: 10px;
    border-style: solid;
    border-color: rgb(200, 200, 200);
    border-width: 0 0 1px 0;
    margin-left: 5px;
    // padding: 8px 5px 2px 5px;
    // padding: 5px;

    > .date-time {
      > input {
        background-color: transparent;

        &:disabled {
          color: black;
          -webkit-text-fill-color: black;
        }
      }
    }

    > .calendar-icon-container {
      cursor: pointer;

      > img {
        height: 15px;
        width: 15px;
      }
    }

    > .calendar {
      width: 100%;
      min-width: 176px;
      padding: 5px;
      background-color: white;
      border: 1px solid black;
      border-radius: 5px;
      user-select: none;

      > .calendar-button {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > button {
          background-color: lightgray;
          font-size: 0.75em;
          padding: 2px 5px;
        }
      }

      > .year-month {
        display: flex;
        font-size: 13px;

        > .content,
        > .content-no-hover {
          flex-grow: 1;
          text-align: center;
        }

        > .content-no-hover {
          cursor: default !important;
        }

        > .next,
        > .previous {
          width: 20px;
          text-align: center;
          cursor: pointer;

          &:hover {
            font-weight: 900;
          }
        }
      }

      > .month-date-section {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        height: 100%;
        width: 100%;

        > .content,
        .content-no-hover {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.8em;
          height: 20px;
          width: 52px;
          background-color: white;
          border: 1px solid transparent;
          margin: 1px;
          transition: $transition-time;
          cursor: pointer;
        }

        > .content-no-hover {
          cursor: default !important;
        }

        > .content:hover,
        .selected {
          background-color: blue;
          border-radius: 100%;
          color: white;
        }

        > .today {
          border: 1px solid black;
          border-radius: 0;
        }

        > .disabled {
          background-color: rgba(64, 64, 64, 0.2) !important;
          border-radius: 100%;

          &:hover {
            color: black;
            cursor: default;
          }
        }
      }

      > .days-date-section {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        height: 100%;
        width: 100%;

        > .content,
        > .content-no-hover {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.8em;
          height: 20px;
          width: 20px;
          background-color: white;
          border: 1px solid transparent;
          margin: 1px;
          transition: $transition-time;
          cursor: pointer;
        }

        > .content-no-hover {
          cursor: default !important;
        }

        > .content:hover,
        > .selected {
          background-color: blue;
          border-radius: 100%;
          color: white;
        }

        > .today {
          border: 1px solid black;
          border-radius: 0;
        }

        > .disabled {
          background-color: rgba(64, 64, 64, 0.2) !important;
          border-radius: 100%;

          &:hover {
            color: black;
            cursor: default;
          }
        }
      }

      > .time-section {
        display: flex;
        justify-content: center;
      }
    }

    > .error-message {
      position: absolute;
      bottom: 1px;
      left: 0;
      background-color: red;
      color: white;
      padding: 1px 5px;
      border-radius: 5px;
      white-space: nowrap;
      overflow: hidden;
      margin-right: 20px;
      text-overflow: ellipsis;
      width: calc(100% - 15px);
      z-index: 9999999;

      &:hover {
        overflow: visible;
        width: unset;
        z-index: 9999999;
      }
    }
  }

  > .disable-block {
    opacity: 1;
    background-color: rgba(200, 200, 200, 0.2);
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 1;
  }
}

.date-time,
.time-section {
  display: flex;

  > input {
    width: 1.5em;
    text-align: center;
    border: none;
    padding: 0;
    // border-color: black;
    // border-width: 0 0 1px 0;
    // border-style: solid;
  }

  > input::-webkit-outer-spin-button,
  > input::-webkit-inner-spin-button {
    display: none;
  }

  > input::placeholder {
    opacity: 0.3;
  }

  > input:disabled {
    color: #222;
    -webkit-text-fill-color: #222;
  }
}

.time-section {
  align-items: baseline;

  > input {
    padding-top: 5px;
    border-color: black;
    border-width: 0 0 1px 0;
    border-style: solid;
  }
}
</style>


<style lang="scss">
.calendar {
  width: 176px;
  padding: 5px;
  background-color: white;
  border: 1px solid black;
  border-radius: 5px;
  user-select: none;
  font-size: 0.85rem;

  > .calendar-button {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > button {
      background-color: lightgray;
      font-size: 0.75em;
      padding: 2px 5px;
    }
  }

  > .year-month {
    display: flex;
    font-size: 13px;

    > .content,
    > .content-no-hover {
      flex-grow: 1;
      text-align: center;
    }

    > .content-no-hover {
      cursor: default !important;
    }

    > .next,
    > .previous {
      width: 20px;
      text-align: center;
      cursor: pointer;

      &:hover {
        font-weight: 900;
      }
    }
  }

  > .month-date-section {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: 100%;
    width: 100%;

    > .content,
    .content-no-hover {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.8em;
      height: 20px;
      width: 52px;
      background-color: white;
      border: 1px solid transparent;
      margin: 1px;
      cursor: pointer;
    }

    > .content-no-hover {
      cursor: default !important;
    }

    > .content:hover,
    .selected {
      background-color: blue;
      border-radius: 100%;
      color: white;
    }

    > .today {
      border: 1px solid black;
      border-radius: 0;
    }

    > .disabled {
      background-color: rgba(64, 64, 64, 0.2) !important;
      border-radius: 100%;

      &:hover {
        color: black;
        cursor: default;
      }
    }
  }

  > .days-date-section {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: 100%;
    width: 100%;

    > .content,
    > .content-no-hover {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.8em;
      height: 20px;
      width: 20px;
      background-color: white;
      border: 1px solid transparent;
      margin: 1px;
      cursor: pointer;
    }

    > .content-no-hover {
      cursor: default !important;
    }

    > .content:hover,
    > .selected {
      background-color: blue;
      border-radius: 100%;
      color: white;
    }

    > .today {
      border: 1px solid black;
      border-radius: 0;
    }

    > .disabled {
      background-color: rgba(64, 64, 64, 0.2) !important;
      border-radius: 100%;

      &:hover {
        color: black;
        cursor: default;
      }
    }
  }

  > .time-section {
    display: flex;
    justify-content: center;
  }
}
</style>
